import script from "./teacherList.vue?vue&type=script&setup=true&lang=js"
export * from "./teacherList.vue?vue&type=script&setup=true&lang=js"

import "./teacherList.vue?vue&type=style&index=0&id=f2e4b84a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2e4b84a"]])

export default __exports__